import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {ConsultRefundParams, GetConsultRefunds, GetConsultRefundsResponse} from 'domain/usecases';

export class RemoteGetConsultRefunds implements GetConsultRefunds {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetConsultRefundsResponse>,
	) {}

	async get(params?: ConsultRefundParams): Promise<GetConsultRefundsResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
